import dayjs from 'dayjs';

(function () {
    'use strict';
    //Service that looks for the flights and passengers information of input locator and surname
    angular
        .module('ib-checkin-services-module')
        .service('SearchFlightsPassengersService', SearchFlightsPassengersService);

    SearchFlightsPassengersService.$inject = ['$rootScope', 'base64', 'CheckForDeepLink', 'GetBookingInformationService', '$location', 'ModalService', 'BookingNameService', 'localStorageService', '$filter', 'CkiDatalayerUtilsService'];
    function SearchFlightsPassengersService ($rootScope, base64, CheckForDeepLink, GetBookingInformationService, $location, ModalService, BookingNameService, localStorageService, $filter, CkiDatalayerUtilsService) {

        var self = this;
        self.searchFlighsPassengersByLocatorAndSurname = searchFlighsPassengersByLocatorAndSurname;
        self.searchFlighsPassengersDeepLink = searchFlighsPassengersDeepLink;
        self.deepLinkChecked = deepLinkChecked;
        self.flightsAndPassengersInfo = {};
        self.surname = '';

        ////////////////

        /**
         * Call service for get booking with surname and locator
         * @param {String} surname
         * @param {String} locator
         */
        function searchFlighsPassengersByLocatorAndSurname (surname, locator, flownSegments) {
            ModalService.isWaiting();
            self.surname = surname;
            //first get booking information service
            GetBookingInformationService.getBookingInformationByLocatorAndSurname(base64.encode(surname), locator, flownSegments)
                .then(bookingInformationGotten, bookingInformationReject);

            function bookingInformationGotten (flightsAndPassengersInfo) {
                self.flightsAndPassengersInfo = flightsAndPassengersInfo;
                $rootScope.timeSession.startTime = dayjs();
                ModalService.isNotWaiting();
                CkiDatalayerUtilsService.updatePnr({ provider: '', reference: localStorageService.get('PNR') });

                //Check for deep link information
                CheckForDeepLink.checkDeepLink(flightsAndPassengersInfo.deepLinkInformation).then(() => {
                    deepLinkChecked(self.flightsAndPassengersInfo);
                });
            }
        }

        /**
         * Call service of deeplink with code recived in params
         * @param {String} code Code codified
         */
        function searchFlighsPassengersDeepLink (code) {
            ModalService.isWaiting();
            //first get booking information service
            GetBookingInformationService.getBookingInformationByDeepLink(code).then(bookingInformationGotten, bookingInformationReject);

            function bookingInformationGotten (flightsAndPassengersInfo) {
                self.flightsAndPassengersInfo = flightsAndPassengersInfo;
                CkiDatalayerUtilsService.updatePnr({ provider: '', reference: localStorageService.get('PNR') });
                //Check for deep link information
                CheckForDeepLink.checkDeepLink(flightsAndPassengersInfo.deepLinkInformation).then(() => {
                    ModalService.isNotWaiting();
                    deepLinkChecked(self.flightsAndPassengersInfo);
                });
            }
        }

        function bookingInformationReject (error) {
            let flowId = null;
            if (error.errorCode === 409) {
                ModalService.isNotWaiting();
                flowId = localStorageService.get('flowId');
                BookingNameService.checkName(self.surname, flowId);
            } else {
                ModalService.isNotWaiting();
                ModalService.setErrorMessage(error.message);
                ModalService.setErrorCode(error.internalErrorCode);
                ModalService.showGenericError(error).result.then(angular.noop, angular.noop);
            }
        }

        function deepLinkChecked (flightsAndPassengersInfo) {
            var segmentsPassengersInfo, error = { message: '' }, onlyChecked = { return: false, outward: false };
            var params = localStorageService.get('urlParams');
            $rootScope.$emit('destroyBanners', true);
            if (params.travelAgencies && params.reInvoicing) {
                segmentsPassengersInfo = localStorageService.get('bookingInfo');
                checkPassengerFlightsStatus(segmentsPassengersInfo);
                deleteNotAvailableSegments(segmentsPassengersInfo);
                onlyChecked = checkSegmentsStates(segmentsPassengersInfo, onlyChecked);
                if (segmentsPassengersInfo.returnSegments.length === 0 && segmentsPassengersInfo.outwardSegments.length === 0) {
                    error.message = $filter('translate')('DE_INVOICING_ERROR_NO_UNDOCHECKIN_SEGMENTS');
                    ModalService.setErrorMessage(error.message);
                    ModalService.showGenericError(error).result.then(angular.noop, angular.noop);
                } else if (!onlyChecked.return && !onlyChecked.outward) {
                    error.message = $filter('translate')('DE_INVOICING_ERROR_ONLY_REISSUE');
                    ModalService.setErrorMessage(error.message);
                    ModalService.showGenericError(error).result.then(angular.noop, angular.noop);
                } else {
                    $location.path('/uncoac');
                }
            } else {
                $location.path('/ibcoac');
            }
        }

        function checkPassengerFlightsStatus (segmentsPassengersInfo) {
            var i, j, checkableCount, uncheckableCount;
            if (segmentsPassengersInfo.returnSegments.length > 0) {
                for (i = 0; i < segmentsPassengersInfo.returnSegments.length; i++) {
                    checkableCount = 0, uncheckableCount = 0;
                    for (j = 0; j < segmentsPassengersInfo.returnSegments[i].passengers.length; j++) {
                        switch (segmentsPassengersInfo.returnSegments[i].passengers[j].status.code) {
                                case 'PENDING AQQ':
                                case 'PENDING EVUS':
                                case 'UNCHECKABLE':
                                    uncheckableCount++;
                                    break;

                                case 'REISSUE':
                                    segmentsPassengersInfo.returnSegments[i].reissue = true;
                                    break;

                                case 'CHECKED':
                                case 'STAND BY':
                                    segmentsPassengersInfo.returnSegments[i].isChecked = true;
                                    break;
                                case 'CHECKABLE':
                                    checkableCount++;
                                    break;
                        }
                    }
                    if (j === checkableCount + uncheckableCount) {
                        segmentsPassengersInfo.returnSegments[i].toDelete = true;
                    }
                }
            }
            if (segmentsPassengersInfo.outwardSegments.length > 0) {
                for (i = 0; i < segmentsPassengersInfo.outwardSegments.length; i++) {
                    checkableCount = 0, uncheckableCount = 0;
                    for (j = 0; j < segmentsPassengersInfo.outwardSegments[i].passengers.length; j++) {
                        switch (segmentsPassengersInfo.outwardSegments[i].passengers[j].status.code) {
                                case 'PENDING AQQ':
                                case 'PENDING EVUS':
                                case 'UNCHECKABLE':
                                    uncheckableCount++;
                                    break;

                                case 'REISSUE':
                                    segmentsPassengersInfo.outwardSegments[i].reissueControl = true;
                                    break;

                                case 'CHECKED':
                                case 'STAND BY':
                                    segmentsPassengersInfo.outwardSegments[i].isChecked = true;
                                    break;
                                case 'CHECKABLE':
                                    checkableCount++;
                                    break;
                        }
                    }
                    if (j === checkableCount + uncheckableCount) {
                        segmentsPassengersInfo.outwardSegments[i].toDelete = true;
                    }
                }
            }
        }

        function deleteNotAvailableSegments (segmentsPassengersInfo) {
            var i;
            for (i = 0; i < segmentsPassengersInfo.returnSegments.length; i++) {
                if (segmentsPassengersInfo.returnSegments[i].toDelete) {
                    segmentsPassengersInfo.returnSegments.splice(i, 1);
                    i--;
                }
            }

            for (i = 0; i < segmentsPassengersInfo.outwardSegments.length; i++) {
                if (segmentsPassengersInfo.outwardSegments[i].toDelete) {
                    segmentsPassengersInfo.outwardSegments.splice(i, 1);
                    i--;
                }
            }
        }

        function checkSegmentsStates (segmentsPassengersInfo, onlyChecked) {
            var i, bReissue = false, bChecked = false;
            for (i = 0; i < segmentsPassengersInfo.returnSegments.length; i++) {
                if (segmentsPassengersInfo.returnSegments[i].reissueControl) {
                    bReissue = true;
                }
                if (segmentsPassengersInfo.returnSegments[i].isChecked) {
                    bChecked = true;
                }
                if (bChecked && !bReissue) {
                    onlyChecked.return = true;
                }
            }
            bChecked = false;
            bReissue = false;
            for (i = 0; i < segmentsPassengersInfo.outwardSegments.length; i++) {
                if (segmentsPassengersInfo.outwardSegments[i].reissueControl) {
                    bReissue = true;
                }
                if (segmentsPassengersInfo.outwardSegments[i].isChecked) {
                    bChecked = true;
                }
                if (bChecked && !bReissue) {
                    onlyChecked.outward = true;
                }
            }
            return onlyChecked;
        }
    }
})();
